import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class AlertControlService {

  // Observable encargado de visualización de container superpuesto
  _showAlertResouce = new BehaviorSubject<any>(null);
  observableAlertShow$ = this._showAlertResouce.asObservable();
  // actualizamos valor, este valor se actualizará en todos los oyentes
  alertSuccess(message: string, param?: any, fixed?: boolean) {
    this._showAlertResouce.next({ status: 'success', message: message, param: param, fixed: fixed });
  }

  alertWarning(message: string, param?: any, fixed?: boolean) {
    this._showAlertResouce.next({ status: 'warning', message: message, param: param, fixed: fixed });
  }

  alertDanger(message: string, param?: any, fixed?: boolean) {
    this._showAlertResouce.next({ status: 'danger', message: message, param: param, fixed: fixed });
  }

  alertUnknownError(fixed?: boolean) {
    this._showAlertResouce.next({ status: 'danger', message: 'GENERAL.NOTIFICATION.UNKNOWN_ERROR', param: null, fixed: fixed });
  }

  alertOther(message: string, param?: any, fixed?: boolean) {
    this._showAlertResouce.next({ status: 'other', message: message, param: param, fixed: fixed });
  }

  alertInfo(message: string, param?: any, fixed?: boolean) {
    this._showAlertResouce.next({ status: 'info', message: message, param: param, fixed: fixed });
  }

  clearAlert() {
    this._showAlertResouce.next({ close: true });
  }

}




// WEBPACK FOOTER //
// ./src/app/services/alert-control.service.ts